module.exports = __webpack_public_path__ + "img/360_step_3.bc5c0af0.png";